export default {"src":"/_next/static/image/src/components/BillingInformationForm/americanexpress.8556ad6cee2c5054fde958e4cd4f5569.svg","height":24,"width":34};